<template>
  <div v-if="showComponent" :class="{ 'iframe-mode': isIframe }">
    <!--START: Vue Headful-->
    <vue-headful :title="meta.title" :description="meta.description" />
    <!--END: Vue Headful-->

    <!--START: Dashboard Header-->
    <DashboardHeader
      v-if="!$route.meta.hideHeader"
      @toggleCompany="toggleCompany"
      @showTaskList="showTaskList"
    ></DashboardHeader>
    <!--END: Dashboard Header-->

    <!--START: How to use button-->
    <a
      v-if="!isIframe"
      href="https://www.youtube.com/playlist?list=PLKsWF-i7CsLOhB3BWbkdyTDqpG8sZSVN3"
      target="_blank"
      class="how-to-use"
    >
      <unicon name="play"></unicon>
      <span>How to use Macha</span>
    </a>
    <!--END: How to use button-->

    <!--START: Router View-->
    <router-view id="dashboard-main" :key="$route.fullPath"></router-view>
    <!--END: Router View-->

    <!--START: Trial Banner-->
    <TrialBanner v-if="showTrialBanner"></TrialBanner>
    <!--END: Trial Banner-->

    <!--START: Subscription-->
    <SubscriptionBanner
      v-else-if="company?.subscription?.status !== 'active'"
    ></SubscriptionBanner>
    <!--END: Subscription-->

    <!--START: Task list-->
    <TaskList
      v-if="company?.subscription?.showTaskList || showOptions.taskList"
      @closeModal="closeModal"
    ></TaskList>
    <!--END: Task List-->

    <!--START: Loader-->
    <LineLoader :show="showOptions.lineLoader"></LineLoader>
    <!--END: Loader-->
  </div>
</template>
  
<script>
// Import components
import DashboardHeader from "@/components/dashboard/Header";
import TrialBanner from "@/components/dashboard/TrialBanner";
import SubscriptionBanner from "@/components/dashboard/SubscriptionBanner";
import TaskList from "@/components/dashboard/TaskList";
import LineLoader from "@/components/loaders/LineLoader";

// Importing services
import { AuthService, CompanyService } from "@/services";

export default {
  name: "Dashboard",
  data() {
    return {
      showComponent: false,
      showOptions: {
        lineLoader: false,
        taskList: false,
      },
      meta: {
        title: "Dashboard - Macha",
        description: "",
      },
    };
  },

  components: {
    DashboardHeader,
    TrialBanner,
    SubscriptionBanner,
    TaskList,
    LineLoader,
  },

  computed: {
    isIframe() {
      return window.self !== window.top;
    },
    user() {
      return this.$store.getters.user.user;
    },
    company() {
      return this.$store.getters.company;
    },
    showTrialBanner() {
      const { subscription } = this.company?.products.aiAssistant;
      return (
        subscription?.planType == "trial" &&
        subscription?.usage.generatedAnswers >= 15
      );
    },
  },

  watch: {
    $route(to) {
      if (!to.meta?.authRoute) this.checkAccess();
      if (to.name === "Logout") this.logoutUser();
    },
  },

  async created() {
    await this.checkAccess();
  },
  methods: {
    // Check if dashboard access can be granted
    async checkAccess() {
      // Set body class to dashboard
      document.body.className = "dashboard";

      // Check to see if the staff is authenticated
      if (await this.authenticateUser()) {
        this.showComponent = true;
        this.checkRedirectRoute();
        this.loadZendeskWidget(this.user);
      } else {
        this.showComponent = false;
        this.redirectSignin();
      }
    },

    // Check if the user has to be redirected anywhere
    checkRedirectRoute() {
      const redirectRoute = this.$store.getters.redirectRoute;
      this.$store.commit("updateRedirectRoute", "");

      if (redirectRoute) this.$router.push({ path: `${redirectRoute}` });
    },

    // Toggle the company
    async toggleCompany(data) {
      this.showOptions.lineLoader = true;
      await AuthService.ToggleCompany(data);

      this.$router.go();
    },

    // Show the task list
    showTaskList() {
      this.showOptions.taskList = true;
    },

    // Load the Zendesk widget
    loadZendeskWidget(user) {
      if (document.getElementById("ze-snippet")) return;

      const script = document.createElement("script");
      script.id = "ze-snippet";
      script.src =
        "https://static.zdassets.com/ekr/snippet.js?key=f06bf424-e247-4b4f-924e-4333df3cf599";
      script.async = true;
      script.onload = () => {
        if (window.zE) {
          window.zE("webWidget", "identify", {
            name: user.email,
            email: user.email,
          });
        }
      };
      document.body.appendChild(script);
    },

    async closeModal() {
      this.showOptions.taskList = false;

      // Disable the task list modal
      if (this.company.subscription.showTaskList) {
        const response = await CompanyService.DisableOnboarding();
        this.$store.commit("updateCompany", response.data);
      }
    },
  },
};
</script>
  
<style scoped lang="scss">
@import "@/assets/styles/shared/dashboard.scss";
.dashboard-view {
  margin: 4.15rem 0 0;
}

.iframe-mode {
  #dashboard-main {
    margin-top: 2.75rem !important;
  }

  /deep/ .page-wrapper {
    height: calc(100vh - 2.75rem);
  }
}

/deep/ {
  .line-loader {
    position: fixed;
    bottom: 0;
  }
}

.how-to-use {
  position: fixed;
  bottom: 4.5rem;
  right: 1rem;
  z-index: 99;
  background: #1e1e1e;
  border-radius: 3rem;
  border: 1px solid lighten(#1e1e1e, 10%);
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.65rem 0.85rem;
  text-decoration: none;
  transition: all 0.3s;
  cursor: pointer;

  .unicon /deep/ svg {
    height: auto;
    width: 0.85rem;
    margin-right: 0.5rem;
    fill: $whiteColor;
    transform: translateY(1px);
  }

  span {
    color: $whiteColor;
    font-size: $smallFontSize;
    line-height: 1;
  }

  &:hover {
    border: 1px solid lighten($purpleColor, 10%);
    background: $purpleColor;
  }
}
</style>